import moment from "moment";
import styles from "./JobDetails2.module.css";
import { GrGroup } from "react-icons/gr";
import { COUNTRY_BY_CODE } from "../../../../constant";

const JobDetails2 = ({ data }) => {
  const handleClick = (item) => {
    console.warn("item", item);
  };

  const handleApply = (item) => {
    console.warn("item", item);
  };
  return (
    <div>
      <div className={styles.title} onClick={handleApply}>
        Apply now!
      </div>
      <div className={styles.description}>
        One click and your application is in along with you IndexScore
      </div>
      <button className={styles.apply_btn}>Apply</button>
      <div className={styles.box}>
        <div className={styles.box_content}>
          <div className={styles.box_title}>About the role</div>

          <div className={styles.lable}>Posted</div>
          <div className={styles.details}>
            {moment(new Date(data.start_date)).format("D MMMM YYYY")}
          </div>

          <div className={styles.lable}>Deadline</div>
          <div className={styles.details}>
            {moment(new Date(data.end_date)).format("D MMMM YYYY")}
          </div>

          <div className={styles.lable}>Job Type</div>
          <div className={styles.details}>{data.employment_type}</div>

          <div className={styles.lable}>Department</div>
          <div className={styles.details}>{data.department}</div>

          <div className={styles.lable}>Location</div>
          <div className={styles.details}>{COUNTRY_BY_CODE[data.job_locations]}</div>
        </div>

        <div className={styles.box_content2}>
          <div className={styles.lable}>Tags</div>
          <div className={styles.badge_group}>
            {data?.job_role_text_keywords?.map((item) => {
              return item === "Hiring Multiple Candidates" ? (
                <div className={styles.badge2}>
                  <GrGroup />
                  {item}
                </div>
              ) : (
                <div className={styles.badge}>{item}</div>
              );
            })}
          </div>
        </div>
      </div>

      {/* <div className={styles.box2}>
        <div className={styles.box_title2}>
          More roles that match this role:
        </div>
        <div className={styles.info}>Click below to view</div>

        {dummayData.roles.map((item) => {
          return (
            <div className={styles.line_wrap}>
              <div className={styles.role_name}>
                {item.name}
                {" - "}{" "}
                <Link to={`/enterprise/${item.company}`}>{item.company}</Link>
              </div>
              <div className={styles.badge} onClick={() => handleClick(item)}>
                View
              </div>
            </div>
          );
        })}
      </div> */}
    </div>
  );
};

export default JobDetails2;
